import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { showUpgradeCardModal } from '../../../../actions'
import { PLANS } from '../../../../constants/plans'
import { onUpgradePlan } from '../../../../utils/general'
import styles from '../../UpdateSiteModal.module.css'
import formStyles from './GameShowcaseForm.module.css'
import { GAME_CATEGORIES } from '../../../../constants'
import { submitGameShowcase } from '../../../../services/games'

export const STATUS_LABEL = {
  pending: 'Pending review - our team will take a look shortly.',
  approved: 'Live in the games showcase.'
}

/**
 * Shared submit-to-showcase form used by the update-project Game Showcase section and the
 * live-projects Submit Game popup. Own submit button so it never touches the parent Formik flow.
 */
const GameShowcaseForm = ({ subdomain, status, onStatusChange, categorySelectId = 'gameShowcaseCategory' }) => {
  const dispatch = useDispatch()
  const userProfile = useSelector((state) => state.manage.userProfile)
  const [category, setCategory] = useState(GAME_CATEGORIES[0])
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState(null)

  const handleSubmit = async () => {
    if (!userProfile?.productId) {
      dispatch(
        showUpgradeCardModal({
          title: 'Upgrade to submit to the showcase',
          desc: 'Submit your game to the showcase on any paid plan.',
          cta: 'Upgrade now',
          onClick: () => onUpgradePlan({ planId: PLANS.TINY.id, userProfile }, dispatch)
        })
      )
      return
    }

    setSubmitting(true)
    setError(null)
    try {
      const result = await submitGameShowcase({ subdomain, gameCategory: category })
      onStatusChange?.(result?.status || 'pending')
    } catch {
      setError('Something went wrong submitting your game - please try again.')
    } finally {
      setSubmitting(false)
    }
  }

  if (status) {
    return <div className={styles.formGroup}>{STATUS_LABEL[status] || 'Submitted for review.'}</div>
  }

  return (
    <>
      <ul className={formStyles.benefits}>
        <li>Get visitors for your game.</li>
        <li>Your game will be featured in our games showcase.</li>
        <li>We&apos;ll promote you to our 2M+ users</li>
      </ul>

      <div className={styles.formGroup}>
        <label htmlFor={categorySelectId}>Category</label>
        <select
          id={categorySelectId}
          className={styles.formControl}
          value={category}
          onChange={(e) => setCategory(e.target.value)}
        >
          {GAME_CATEGORIES.map((c) => (
            <option key={c} value={c}>
              {c}
            </option>
          ))}
        </select>
      </div>

      {error && <div className={styles.errorText}>{error}</div>}

      <button type="button" className={styles.publishBtn} onClick={handleSubmit} disabled={submitting}>
        {submitting ? 'Submitting...' : 'Submit to Showcase'}
      </button>
      <div className="font-small text-center mt-2 grey">Free to submit - active subscription required</div>
    </>
  )
}

export default GameShowcaseForm
